import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntercomComponent } from './components/icon/intercom.component';
import { IntercomRunService } from './run/intercom.run.service';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonEventTriggerModule } from '@monsido/angular-shared-components';

export function initializeIntercom (intercomRunService: IntercomRunService): () => Promise<void> {
    return () => Promise.resolve().then(() => {
        intercomRunService.setupEventListeners();
        return;
    });
}

@NgModule({
    declarations: [
        IntercomComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        MonEventTriggerModule,
    ],
    exports: [
        IntercomComponent,
    ],
    providers: [
        IntercomRunService,
        provideAppInitializer(() => {
            const initializerFn = (initializeIntercom)(inject(IntercomRunService));
            return initializerFn();
        }),
    ],
})
export class IntercomModule { }
